import PhotoDocumentsReject from './PhotoDocumentsReject';

export default PhotoDocumentsReject;
